import { BookCornSchema, isContactCorn, } from '@eigtech/contacts-types';
import { getCornKernels, makeCorn } from '@eigtech/shared-corn';
export const makeBookCorn = (resourceId) => makeCorn({ serviceName: 'contacts', resourceType: 'book', resourceId });
export const makeGlobalBookCorn = (resourceId) => `corn:contacts:book:${resourceId}`;
export const ensureBookCorn = (bookId) => isBookCorn(bookId) ? bookId : makeBookCorn(bookId);
export const ensureContactCorn = (contactId) => isContactCorn(contactId) ? contactId : `corn:contacts:contact:${contactId}`;
export const isBookCorn = (bookId) => BookCornSchema.safeParse(bookId).success;
export const getGlobalBookResourceId = (corn) => getCornKernels(corn).resourceId;
